import { RouterUtil } from './router-util';

export class RouteUtil {
    static getHomeRouteUrl() {
        return `/${RouterUtil.Cog.Home}`;
    }

    static getOrdersRouteUrl() {
        return `/${RouterUtil.Cog.Account}/${RouterUtil.Cog.Orders}`;
    }

    static getOrderRouteUrl(id: string) {
        return this.getOrdersRouteUrl() + `/${id}`;
    }

    static getOrderStatusRouteUrl(id: string) {
        return this.getOrderRouteUrl(id) + `/${RouterUtil.Cog.Status}`;
    }

    static getOrderTrackingRouteUrl(id: string) {
        return this.getOrderRouteUrl(id) + `/${RouterUtil.Cog.Tracking}`;
    }

    static getOrderRatingRouteUrl(id: string) {
        return this.getOrderRouteUrl(id) + `/${RouterUtil.Cog.Rating}`;
    }

    static getAccountRouteUrl() {
        return `/${RouterUtil.Cog.Account}`;
    }

    static getAboutRouteUrl() {
        return `/${RouterUtil.Cog.About}`;
    }

    static getProfileRouteUrl() {
        return `/${RouterUtil.Cog.Account}/${RouterUtil.Cog.Profile}`;
    }

    static getAddressBookRouteUrl() {
        return `/${RouterUtil.Cog.Account}/${RouterUtil.Cog.AddressBook}`;
    }

    static getLoginRouteUrl() {
        return `/${RouterUtil.Cog.Login}`;
    }

    static getLoginVerifyOtpRouteUrl() {
        return `/${RouterUtil.Cog.Login}/${RouterUtil.Cog.Verify}`;
    }

    static getNotificationsRouteUrl() {
        return `/${RouterUtil.Cog.Notifications}`;
    }

    static getCartRouteUrl() {
        return `/${RouterUtil.Cog.Cart}`;
    }

    static getCartCheckoutRouteUrl() {
        return `/${RouterUtil.Cog.Cart}/${RouterUtil.Cog.Checkout}`;
    }

    static getProductsRouteUrl() {
        return `/${RouterUtil.Cog.Products}`;
    }

    static getCheckoutRouteUrl() {
        return `/${RouterUtil.Cog.Checkout}`;
    }

    static getCheckoutDeliveryAddressRouteUrl() {
        return `/${RouterUtil.Cog.Checkout}/${RouterUtil.Cog.DeliveryAddress}`;
    }

    static getShopsRouteUrl() {
        return `/${RouterUtil.Cog.Shops}`;
    }

    static getShopRouteUrl(shopId: string) {
        return `/${RouterUtil.Cog.Shops}/${shopId}`;
    }

    static getContactRouteUrl() {
        return `/${RouterUtil.Cog.Shop}/${RouterUtil.Cog.Contact}`;
    }

    static getSettingRouteUrl() {
        return `/${RouterUtil.Cog.Setting}`;
    }

    static getRatingRouteUrl(id: string) {
        return this.getOrderRouteUrl(id) + `/${RouterUtil.Cog.Rating}`;
    }

    static getStoresRouteUrl() {
        return `/${RouterUtil.Cog.Stores}`;
    }

    static getStoreRouteUrl(id: string) {
        return `/${RouterUtil.Cog.Stores}/${id}`;
    }

    static getDeliveryAddressesRouteUrl() {
        return `/${RouterUtil.Cog.DeliveryAddresses}`;
    }

    static getDeliveryAddressRouteUrl(id: string) {
        return `/${RouterUtil.Cog.DeliveryAddresses}/${id}`;
    }

    static getCreateAddressRouteUrl() {
        return `/${RouterUtil.Cog.DeliveryAddresses}/create`;
    }

    static getSelectDeliveryAddressRouteUrl() {
        return `/${RouterUtil.Cog.SelectDeliveryAddress}`;
    }

    static getSelectStoreRouteUrl() {
        return `/${RouterUtil.Cog.SelectStore}`;
    }

    static getSelectTreatmentCardRouteUrl() {
        return `/${RouterUtil.Cog.Account}/${RouterUtil.Cog.TreatmentCard}`;
    }
}
